import { uiStateSelector, useStore } from '@liveHelper/models/store'

/**
 * Hook to return UTM content based on the UI state.
 * @returns The UTM content based on the UI state.
 */
export const useGetUtmContent = () => {
  const uiState = useStore(uiStateSelector)

  return [
    'chatting_dialing',
    'chatting_ringing',
    'chatting_on_call',
    'dialing_minimized',
    'on_call_minimized',
    'on_call_fullscreen',
  ].includes(uiState)
    ? 'oto_video'
    : 'oto_chat'
}
